import { render } from "./memberCard.vue?vue&type=template&id=f8993ae4"
import script from "./memberCard.vue?vue&type=script&lang=js"
export * from "./memberCard.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__